// removed by extract-text-webpack-plugin
module.exports = {"videoWrapper":"_1pc2tOIKVk_GAqD9WH21df"};


//////////////////
// WEBPACK FOOTER
// ./src/components/providers/youtube/youtube.css
// module id = 1072
// module chunks = 0